/*
 * @Author: wangshengqiang
 * @Date: 2021-04-22 17:38:15
 * @LastEditTime: 2022-01-23 12:48:26
 * @LastEditors: wangshengqiang
 * @Description: 理赔流程
 */
import React, { useState } from 'react';
import classnames from 'classnames';
import { Tabs } from 'zarm';
import './index.less';
const {
  Panel
} = Tabs;

const Title = props => {
  const {
    title,
    className
  } = props;
  const changeFormat = title.split(';').map(r => {
    if (r.includes('rgb')) {
      r = r.replace(')', ')!important ;');
      return r;
    }

    return r;
  }).join();
  const styleClass = /class/img.test(changeFormat) ? '' : 'align-items: flex-start'; // const styleColor = /rgb/img.test(changeFormat) ? '' : 'color: #343434';

  const cls = classnames({
    'c-tab-title': true,
    [className]: !!className
  });

  const _html = title ? `<div class="${cls}" style='${styleClass}'>${changeFormat}</div>` : '';

  return /*#__PURE__*/React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: _html
    }
  });
};

const ClaimFlow = props => {
  const {
    Render,
    id,
    attrs
  } = props;
  const {
    dataSource = []
  } = attrs;
  const [activeIndex, setActiveIndex] = useState(0);

  if (dataSource.length === 0) {
    return null;
  }

  return /*#__PURE__*/React.createElement("div", {
    id: id,
    className: "c-claimflow-component  bg-fff"
  }, /*#__PURE__*/React.createElement("div", {
    className: "claimflow-container"
  }, /*#__PURE__*/React.createElement(Tabs, {
    onChange: setActiveIndex
  }, dataSource.map((item, index) => {
    const active = activeIndex === index;
    const cls = classnames({
      'tab-title': true,
      noBottom: false,
      active
    });

    if (dataSource.length <= 1 && [11, 13].includes(item.label.length) && item.label.includes('<br>')) {
      return /*#__PURE__*/React.createElement(Panel, {
        key: index
      }, /*#__PURE__*/React.createElement(Render, {
        components: item.children
      }));
    }

    return /*#__PURE__*/React.createElement(Panel, {
      key: index,
      title: /*#__PURE__*/React.createElement(Title, {
        className: cls,
        title: item.label
      })
    }, /*#__PURE__*/React.createElement(Render, {
      components: item.children
    }));
  }))));
};

export default ClaimFlow;